<template>
  <td
    :key="isSelected"
    class="connection-container"
    :class="{ 'elevation-2': isSelected, lastTube: lastTube}"
    :style="{
      'background-color': isSelected ? 'lightgrey' : 'none'
    }"
    @click="click"
    @contextmenu="$emit('contextmenu', $event)"
  >
    <v-layout align-center :justify-end="justifyEnd">
      <slot />
    </v-layout>
  </td>
</template>

<script>
export default {
  name: "TableDataConnectionPoint",

  props: {
    isSelected: Boolean,

    justifyEnd: Boolean,

    lastTube:Boolean,

    disabled: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    click() {
      if (!this.disabled) {
        this.$emit("click");
      }
    }
  }
};
</script>
<style>
.connection-container{
  width: 50%;
  display: flex;
  align-items: center;
  border-bottom: .5px solid rgb(158, 153, 153)
}
.lastTube{
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataConnectionPoint.vue